import { UntypedFormControl } from '@angular/forms';

export class InterchangeModel {
  brandLabel: UntypedFormControl;
  brandId: UntypedFormControl;
  partNumber: UntypedFormControl;
  typeCode: UntypedFormControl;
  qualityGradeLevel: UntypedFormControl;
  languageCode: UntypedFormControl;
  interchangeNotes: UntypedFormControl;
  internalNotes: UntypedFormControl;
}
